export default function ($) {

  const blockSliderSwiper = new Swiper('.js-block-slider-swiper', {
    slidesPerView: '1',
    loop: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-slider',
      prevEl: '.swiper-button-prev-slider',
    },
  });

  const blockCommitmentSliderSwiper = new Swiper('.js-block-commitment-slider-swiper', {
    slidesPerView: '1',
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    on: {
      init: function () {
        equalizeSlideHeights(this);
      },
      resize: function () {
        equalizeSlideHeights(this);
      }
    }
  });

  function equalizeSlideHeights(swiper) {
    swiper.slides.forEach(slide => {
      slide.querySelector('.commitment-slider-content').style.height = '';
    });

    let maxHeight = 0;
    swiper.slides.forEach(slide => {
      const height = slide.querySelector('.commitment-slider-content').offsetHeight;
      maxHeight = Math.max(maxHeight, height);
    });

    swiper.slides.forEach(slide => {
      slide.querySelector('.commitment-slider-content').style.height = `${maxHeight}px`;
    });
  }

  const productsSwiper = new Swiper('.js-products-swiper', {
    slidesPerView: '1.4',
    loop: false,
    spaceBetween: 32,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar-products-swiper',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-products-swiper',
      prevEl: '.swiper-button-prev-products-swiper',
    },
    breakpoints: {
      480: {
        slidesPerView: '2',
        spaceBetween: 24,
      },
      640: {
        slidesPerView: '2.5',
        spaceBetween: 24,
      },
      768: {
        slidesPerView: '3',
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: '3.5',
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: '4.2',
        spaceBetween: 32,
      },
      1536: {
        slidesPerView: '4.5',
        spaceBetween: 32,
      },
      1664: {
        slidesPerView: '5',
        spaceBetween: 32,
      },
      1920: {
        slidesPerView: '5.5',
        spaceBetween: 32,
      },
    },
  });

  const postsSwiper = new Swiper('.js-posts-swiper', {
    slidesPerView: '1.2',
    loop: false,
    spaceBetween: 32,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar-posts-swiper',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-posts-swiper',
      prevEl: '.swiper-button-prev-posts-swiper',
    },
    breakpoints: {
      640: {
        slidesPerView: '2',
        spaceBetween: 24,
      },
      768: {
        slidesPerView: '2.2',
        spaceBetween: 24,
      },
      1024: {
        slidesPerView: '3.2',
        spaceBetween: 32,
      },
      1280: {
        slidesPerView: '3.2',
        spaceBetween: 32,
      },
      1536: {
        slidesPerView: '4.2',
        spaceBetween: 32,
      },
    },
  });

  const productMainSwiper = new Swiper('.js-product-main-swiper', {
    loop: false,
    spaceBetween: 0,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  });

  const productThumbnailsSwiper = new Swiper('.js-product-thumbnails-swiper', {
    direction: 'horizontal',
    slidesPerView: '3',
    loop: false,
    spaceBetween: 16,
    navigation: {
      nextEl: '.swiper-button-next-products-thumbails-swiper',
      prevEl: '.swiper-button-prev-products-thumbails-swiper',
    },
    breakpoints: {
      640: {
        direction: 'horizontal',
        slidesPerView: '4',
        spaceBetween: 24,
      },
      768: {
        direction: 'horizontal',
        slidesPerView: '4',
        spaceBetween: 24,
      },
      1024: {
        direction: 'vertical',
        slidesPerView: '3',
        spaceBetween: 24,
      },
    },
  });

  window.jsProductMainSwiper = productMainSwiper;
  window.jsProductThumbnailsSwiper = productThumbnailsSwiper;

  // Synchronisation des sliders
  productThumbnailsSwiper.on('click', function(swiper, event) {
    const clickedIndex = swiper.clickedIndex;
    if (typeof clickedIndex !== 'undefined') {
      productMainSwiper.slideTo(clickedIndex);
    }
  });

  productMainSwiper.on('slideChange', function() {
    productThumbnailsSwiper.slideTo(this.realIndex);
  });

  const heroHomeSwiper = new Swiper('.js-hero-home-swiper', {
    slidesPerView: '1',
    loop: false,
    pagination: {
      el: '.swiper-pagination-home-slider',
      clickable: true,
    },
  });

  const productCatsSwiper = new Swiper('.js-product-cats-swiper', {
    slidesPerView: 'auto',
    loop: false,
    spaceBetween: 12,
    centerSlides: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: '.swiper-button-next-product-cats-swiper',
      prevEl: '.swiper-button-prev-product-cats-swiper',
    },
  });

  const productsBrandsSwiper = new Swiper('.js-products-brands-swiper', {
    slidesPerView: '1.2',
    loop: false,
    spaceBetween: 40,
    scrollbar: {
      el: '.swiper-scrollbar-product-brands-swiper',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-product-brands-swiper',
      prevEl: '.swiper-button-prev-product-brands-swiper',
    },
    breakpoints: {
      480: {
        slidesPerView: '1.4',
      },
      640: {
        slidesPerView: '1.8',
      },
      768: {
        slidesPerView: '2.2',
      },
      1024: {
        slidesPerView: '3',
      },
      1280: {
        slidesPerView: '3.7',
      },
      1536: {
        slidesPerView: '4.5',
      },
    },
  });

  const crossSellProductsSwiperParams = {
    slidesPerView: '1.4',
    loop: false,
    spaceBetween: 32,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar-products-swiper',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-products-swiper',
      prevEl: '.swiper-button-prev-products-swiper',
    },
    breakpoints: {
      480: {
        slidesPerView: '2',
        spaceBetween: 24,
      },
      640: {
        slidesPerView: '2.5',
        spaceBetween: 24,
      },
      768: {
        slidesPerView: '1',
        spaceBetween: 24,
      },
    },
  };

  const crossSellProductsSwiper = new Swiper('.js-cross-sell-products-swiper', {
    slidesPerView: '1',
    loop: false,
    spaceBetween: 32,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar-products-swiper',
      draggable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next-products-swiper',
      prevEl: '.swiper-button-prev-products-swiper',
    },
    breakpoints: {
      1024: {
        slidesPerView: '1.5',
        spaceBetween: 24,
      },
      1280: {
        slidesPerView: '2',
        spaceBetween: 24,
      },
      1536: {
        slidesPerView: '2.5',
      },
    },
  });
}
